import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Privilege9Guard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const admin = JSON.parse(localStorage.getItem('admin') || '{}');
    
    if (admin?.privilege_id === 9) {
      return true;
    }
    
    this.router.navigate(['/admins/list-clients']);
    return false;
  }
}